<template>
  <div v-if="fields.length">
    <div class="text-subtitle-2 mt-2 mb-1">{{ $t('onboarding.tunnel.custom-fields.title', { organization }) }}</div>
    <p class="text-caption text--secondary mb-3">{{ $t('onboarding.tunnel.custom-fields.why') }}</p>
    <v-row dense>
      <v-col v-for="field in fields" :key="field.id" cols="12">
        <v-textarea
            v-if="field.type === 'paragraph'"
            :value="value[field.id]"
            :label="labelOf(field)" :hint="field.description || ''" persistent-hint
            :rules="rulesOf(field)" rows="3" auto-grow outlined dense
            @input="set(field, $event)"
        />
        <v-text-field
            v-else-if="field.type === 'number'"
            :value="value[field.id]"
            type="number"
            :label="labelOf(field)" :hint="field.description || ''" persistent-hint
            :rules="rulesOf(field)" outlined dense
            @input="set(field, $event)"
        />
        <v-switch
            v-else-if="field.type === 'bool'"
            :input-value="value[field.id] === true"
            :label="labelOf(field)" :hint="field.description || ''" persistent-hint
            dense class="mt-0"
            @change="set(field, !!$event)"
        />
        <v-select
            v-else-if="field.type === 'choice'"
            :value="value[field.id]"
            :items="choicesOf(field)"
            :label="labelOf(field)" :hint="field.description || ''" persistent-hint
            :rules="rulesOf(field)" clearable outlined dense
            @change="set(field, $event)"
        />
        <v-text-field
            v-else
            :value="value[field.id]"
            :label="labelOf(field)" :hint="field.description || ''" persistent-hint
            :rules="rulesOf(field)" outlined dense
            @input="set(field, $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
/**
 * Les champs personnalisés que le type de membre demande, à l'étape « Vous » du tunnel : texte,
 * paragraphe, nombre, oui/non, liste de choix. Les obligatoires sont marqués et exigés ; le serveur
 * vérifie de nouveau.
 *
 * La valeur : un objet identifiant du champ → valeur.
 */
export default {
  name: 'TunnelCustomFields',

  props: {
    fields: { type: Array, default: () => [] },
    value: { type: Object, default: () => ({}) },
    organization: { type: String, default: '' },
  },

  methods: {
    labelOf(field) {
      return field.required ? `${field.label} *` : field.label
    },

    rulesOf(field) {
      return field.required ? [v => (v !== null && v !== undefined && String(v).trim() !== '') || this.$t('onboarding.tunnel.custom-fields.required')] : []
    },

    /** Une liste de choix donne des chaînes, ou des paires { text, value }. */
    choicesOf(field) {
      return (field.choices || []).map(choice => (typeof choice === 'object' ? choice : { text: choice, value: choice }))
    },

    set(field, raw) {
      const value = field.type === 'number' && raw !== '' && raw !== null ? Number(raw) : raw
      this.$emit('input', { ...this.value, [field.id]: value })
    },
  },
}
</script>
